import script from "./NewMixView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMixView.vue?vue&type=script&setup=true&lang=js"

import "./NewMixView.vue?vue&type=style&index=0&id=71a05374&lang=css"

const __exports__ = script;

export default __exports__